export default "__VITE_ASSET__BgUuCMPG__"